import Cookies from 'js-cookie';

const COOKIE = 'page_count';

function setPageCount(newCount) {
  Cookies.set(COOKIE, newCount, {path: '/'});
  return newCount;
}

export function getPageCount() {
  const count = Cookies.get(COOKIE);
  return count ? parseInt(count, 10) : 0;
}

export function incrementPageCount() {
  const currentCount = getPageCount();
  return setPageCount(currentCount + 1);
}
